var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.025 508.025",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C0EB"
    },
    d: "M254.012,348.025l241.7,152.2c7.5-6.2,12.2-15.5,12.2-26v-286.2L254.012,348.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M0.013,188.025v286.2c0,10.5,4.8,19.8,12.3,26c5.9,4.8,13.4,7.8,21.6,7.8h440.2 c8.2,0,15.7-2.9,21.6-7.8L0.013,188.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M266.513,4.125c-7.5-5.5-17.6-5.5-25.1,0l-241.4,183.9l49.8,31.4l24.5,15.5l179.7,113.1l179.7-113.2 l24.5-15.4l49.8-31.4L266.513,4.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M371.013,33.825h-300c-11.7,0-21.2,9.4-21.2,21.1v164.5l24.5,15.5l179.7,113.1l179.7-113.2l24.5-15.4 v-98.8L371.013,33.825z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6E0"
    },
    d: "M371.013,33.825v65.8c0,11.6,9.5,21.1,21.2,21.1h66L371.013,33.825z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.012,
    y: 100.325,
    style: {
      fill: "#CDD6E0"
    },
    width: 173.7,
    height: 20.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.012,
    y: 161.125,
    style: {
      fill: "#CDD6E0"
    },
    width: 234,
    height: 20.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.012,
    y: 221.925,
    style: {
      fill: "#CDD6E0"
    },
    width: 234,
    height: 20.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4a9c8932cc7a230f88c75c18330bb5a4.svg";
export { ForwardRef as ReactComponent };